import { useMaterialModel } from 'api';
import HoldPhone from 'assets/camera-guide-illustrations/hold-phone.png';
import InstantFeedback from 'assets/camera-guide-illustrations/instant-feedback.png';
import PhoneAngle from 'assets/camera-guide-illustrations/phone-angle.png';
import { BaleEvidenceGallery, UploadOptionsButton, useSiteMaterial, useToggleCamera } from 'features';
import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ActionRow, Button, Grid, Page, Section, Typography, useBreakpoint } from 'ui';

import { SiteHeader } from '../../components/SiteHeader/SiteHeader';

export const BalePhotos = () => {
  const { data: siteMaterial } = useSiteMaterial();
  const { isCameraOpen, toggle: toggleCamera } = useToggleCamera();
  const { isMobile } = useBreakpoint();
  const filePickerRef = useRef<HTMLInputElement>(null);
  const model = useMaterialModel(String(siteMaterial?.public_id));

  if (!siteMaterial) {
    return <Typography>Material not found</Typography>;
  }

  const handleFileSelect = () => {
    filePickerRef.current?.click();
  };

  return (
    <Page>
      <Page.Title title="Photo Evidence" />
      <Page.Divider />

      <Grid container>
        <Grid item xs={12} md={4}>
          <Section title="Site Details">
            <SiteHeader siteMaterial={siteMaterial} />
          </Section>
        </Grid>
        <Grid item xs={12} md={8}>
          <Section
            title="Evidence"
            action={
              <ActionRow>
                <Button size="large" fullWidth variant="secondary" component={Link} to="edit">
                  Edit
                </Button>
                <UploadOptionsButton onUpload={handleFileSelect} onOpenCamera={toggleCamera} isMobile={isMobile} />
              </ActionRow>
            }
          >
            <BaleEvidenceGallery
              onToggleCamera={toggleCamera}
              isCameraOpen={isCameraOpen}
              filePickerRef={filePickerRef}
              siteMaterial={siteMaterial}
              model={model}
              guideIllustrations={{
                holdPhone: HoldPhone,
                instantFeedback: InstantFeedback,
                phoneAngle: PhoneAngle,
              }}
            />
          </Section>
        </Grid>
      </Grid>
    </Page>
  );
};
